import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SiteContext = createContext({ orderingOpen: false, sourcingWhere: {}, notify: () => {}, signup: null, closeSignup: () => {} });

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({ ordering_open: false, sourcing_where: {} });
  const [signup, setSignup] = useState(null);

  useEffect(() => {
    axios.get(`${API}/site-settings`).then((r) => setSettings(r.data || {})).catch(() => {});
  }, []);

  const value = {
    orderingOpen: !!settings?.ordering_open,
    sourcingWhere: settings?.sourcing_where ?? {},
    notify: (interest = "") => setSignup({ interest }),
    signup,
    closeSignup: () => setSignup(null),
  };
  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
